import React from 'react';

const Tabs = ({active,setActive}) => {
  return (
    <div className="hide_on_large container-fluid">
      <div className="row">
      <div onClick={()=> setActive(true)} className={`col-6 my_slide d-flex justify-content-center align-items-center py-3 h4desc ${active ? "active_slide check": ""}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
          <path fillRule="evenodd" clipRule="evenodd" d="M4 8H8V4H4V8ZM10 20H14V16H10V20ZM4 20H8V16H4V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 4V8H20V4H16ZM10 8H14V4H10V8ZM16 14H20V10H16V14ZM16 20H20V16H16V20Z" />
        </svg> &nbsp; Listings
      </div>
      <div onClick={()=> setActive(false)} className={`col-6 my_slide d-flex justify-content-center align-items-center py-3 h4desc ${!active ? "active_slide check": ""}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
          <path fillRule="evenodd" clipRule="evenodd" d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" />
        </svg> &nbsp; Maps
      </div>
      </div>
    </div>
  );
};

export default Tabs;